module.exports = __webpack_public_path__ + "static/media/Vector.0f9eac69.svg";